import React, { FC } from "react";
import Box from "@mui/material/Box";
import { iYourQuoteProps } from "../../../types/contentType";

import "./yourQuote.css";

const YourQuote: FC<iYourQuoteProps> = ({ yourQuote, yourQuotePrice }) => {
	const yourQuoteBoxContent = yourQuote || yourQuotePrice || "";
	return (
		<>
			{yourQuoteBoxContent && (
				<Box className="yourQuote">
					<small>{yourQuote}</small>
					{yourQuotePrice && <strong>AED {yourQuotePrice}</strong>}
				</Box>
			)}
		</>
	);
};
export default YourQuote;
